import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import VesselCard from "./VesselCard";

const DraggableVesselCard = ({ vessel, columnId, onVesselClick }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging, } = useSortable({ id: vessel.id.toString(), data: { columnId, vessel } });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    marginBottom: 4,
    marginTop: 4
  };
  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onClick={(e) => {
        e.stopPropagation();
        onVesselClick(vessel);
      }}
    >
      <VesselCard
        vessel={vessel}
        isDragging={isDragging}
        onVesselClick={onVesselClick}
      />
    </div>
  );
};

export default DraggableVesselCard;